import React, { useRef, useState } from 'react';

const IDLE_TRANSFORM = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';

const TiltCard = ({ children, className = '' }) => {
  const cardRef = useRef(null);
  const rafIdRef = useRef(null);
  const [transform, setTransform] = useState('');
  const [hovering, setHovering] = useState(false);

  const handleMouseEnter = () => setHovering(true);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    // rAF-throttle: one update per frame max, prevents tearing during scroll
    if (rafIdRef.current) return;
    const { clientX, clientY } = e;
    rafIdRef.current = window.requestAnimationFrame(() => {
      rafIdRef.current = null;
      const card = cardRef.current;
      if (!card) return;
      const rect = card.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = ((y - centerY) / centerY) * -10;
      const rotateY = ((x - centerX) / centerX) * 10;
      setTransform(
        `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`
      );
    });
  };

  const handleMouseLeave = () => {
    if (rafIdRef.current) {
      window.cancelAnimationFrame(rafIdRef.current);
      rafIdRef.current = null;
    }
    setHovering(false);
    setTransform(IDLE_TRANSFORM);
  };

  return (
    <div
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={className}
      style={{
        transform: transform,
        transition: 'transform 0.2s ease-out',
        // Only promote to its own GPU layer while the cursor is actually on the card.
        // Keeping willChange:'transform' permanently on every card was forcing the
        // browser to recomposite 6+ layers on every scroll frame, causing stutter.
        willChange: hovering ? 'transform' : 'auto',
      }}
    >
      {children}
    </div>
  );
};

export default TiltCard;
